/**
 * Per-route header titles (the persistent top-bar heading). Most pages also render their own body
 * h1 with specifics; the inventory hub uses THIS as its sole title (its tabs render no body h1).
 * Kept pure + separate from <SiteHeader> so the map is unit-testable and stays in sync with the
 * router: KEYS MUST MATCH the paths in router.tsx. A path with no entry falls back to 'Dashboard'.
 */
export const PAGE_TITLES: Record<string, string> = {
  '/quote/screen-print': 'Screen print quote',
  '/orders': 'Orders',
  '/production': 'Production',
  '/activity': 'Activity',
  '/designs': 'Designs',
  '/catalog': 'Product catalog',
  // Settings pages live under /settings/* (sidebar PR-2); the old top-level paths redirect (router.tsx).
  '/settings/stores': 'Stores',
  '/settings/purchasing': 'Purchasing',
  '/batches': 'Gang sheets',
  '/screen-print': 'Screen print',
  '/reprint-queue': 'Reprint queue',
  '/press': 'Press station',
  '/fulfill': 'Ship-only',
  '/scan': 'Scan station',
  '/ship': 'Ship station',
  '/settings/film-rolls': 'Film rolls',
  '/settings/presses': 'Presses',
  '/count': 'Count the shelf',
  // The blank-inventory hub — every tab shares this one title (the hub's h1 says "Inventory"; the
  // tab bar carries the specifics). Keys MUST match the router's /inventory/* paths (inventory-hub.tsx).
  // /inventory/short redirects into /inventory?filter=short since the 2026-08 tab merge.
  '/inventory': 'Inventory',
  '/inventory/purchase-draft': 'Inventory',
  '/inventory/receiving': 'Inventory',
  '/inventory/inbound': 'Inventory',
  '/inventory/transfers': 'Inventory',
  '/inventory/garments': 'Inventory',
  '/inventory/items': 'Inventory',
  '/caps': 'Caps',
  '/settings/pricing': 'Pricing config',
};

export function titleForPath(pathname: string): string {
  // Dynamic route with no static key: the order job-card (/orders/:storeId/:orderId). Checked before
  // the fallback so the card stops reading as a generic "Dashboard" (production-records R0).
  if (pathname.startsWith('/orders/')) return 'Order';
  // The gang-sheet workbench keeps its list title on a selected sheet (/batches/:batchId).
  if (pathname.startsWith('/batches/')) return 'Gang sheets';
  return PAGE_TITLES[pathname] ?? 'Dashboard';
}
